import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export const importItinerariesFormGroup = (formBuilder: FormBuilder): FormGroup => {
  return formBuilder.group({
    file: ['', Validators.required],
  });
};